<template>
  <form class="dialog-delete-notice" method="post" :action="url" id="form">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <p class="title">
          {{ $t('notices.delete.title') }}
        </p>
        <p class="description">
         {{ textType }}
        </p>
        <p class="date">
          {{ $dayjs(notice.created_at).format('YY/MM/DD') }}
        </p>
        <p class="notice-title">
          {{ notice.title }}
        </p>
      </div>
      <div class="footer">
        <el-button type="primary" @click="deleteNotice" class="btn btn-delete">{{ $t('notices.btn_delete') }}</el-button><br>
        <el-button @click="handleClose" class="btn btn-back">{{ $t('notices.btn_cancle_delete') }}</el-button>
      </div>
    </el-dialog>
  </form>
</template>

<script>
  export default {
    props: {
      openPopup: { type: Boolean, required: true, default: false },
      notice: { type: Object, required: true, default: {} },
      url: { type: String, required: true, default: '' },
    },
    emits: ['isClosePopup'],
    data() {
      return {
        outerVisible: false,
        innerVisible: false,
        dialog: '',
        isClose: false,
        loading: false,
        textType: ''
      };
    },
    methods: {
      handleClose() {
        this.$emit('isClosePopup');
      },

      deleteNotice() {
        this.loading = true;
        document.querySelector(".el-dialog__body").classList.add("disabled");
        const form = document.getElementById('form');
        form.submit();
      },
    },

    created() {
      this.dialog = this.openPopup;
      this.textType = (this.notice.type == this.$noticeType.user) ? this.$t('notices.textType.user') : this.$t('notices.textType.partner');
    }
  }
</script>

<style lang="scss">
  .dialog-delete-notice {
    text-align: center !important;
    .el-dialog {
      --el-dialog-width: 760px;
      --el-dialog-margin-top: 10vh;
      height: 600px;
      .el-dialog__body {
        margin-top: 12%;
      }
    }
    .title {
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      font-weight: 700;
      padding-bottom: 16px;
      margin: 0;
    }
    .date {
      margin: 0;
      padding: 8px 0;
      letter-spacing: 1.3px;
      color: #000000;
    }
    .description {
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #000000;
      margin: 0;
    }
    .notice-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: Ellipsis;
      max-width: 47ch;
      text-align: center;
      margin: 0 auto;
      letter-spacing: 1.3px;
      color: #000000;
    }
    .footer {
      margin-top: 30px;
      padding-left: 20px;
      .btn {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 250px;
        height: 50px;
        border-radius: 25px !important;
      }
      .btn-delete {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
      }
      .btn-back {
        background: #969696 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #969696;
        --el-button-hover-border-color: #969696;
        --el-button-border-color: #969696;
        margin-top: 10px;
      }
    }
  }
</style>
